import { useNprogress } from 'src/hooks/use-nprogress';
import LinearProgress from '@mui/material/LinearProgress';

export const Loading = () => {
  const { isLoading } = useNprogress();
  return <>{isLoading && <LinearProgress />}</>;
};
